import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import InvestmentModel from '../models/InvestmentModel';
import ItemsAndTypesModel from '../models/ItemsAndTypesModel';

interface InvestmentInputState {
    input: InvestmentModel,
    selectedInvestmentId: string,
    InvestmentInputExpand: boolean,
    triggerFocusCompanyNameInput: number,
    triggerSave: number,
    triggerRefreshInput: number,
    itemsAndTypes: ItemsAndTypesModel,
    showInvestmentDetail: boolean
}

const initialState: InvestmentInputState = {
    input: {
        id: "",
        investmentDate: "",
        items: "",
        type: "",
        amount: 0,
        settleDate: "",
        interest: 0,
        description: "",
    } as unknown as InvestmentModel,
    selectedInvestmentId: "",
    InvestmentInputExpand: true,
    triggerFocusCompanyNameInput: 0,
    triggerSave: 0,
    triggerRefreshInput: 0,
    itemsAndTypes: {
        items: [],
        types: []
    } as ItemsAndTypesModel,
    showInvestmentDetail: false
}

export const InvestmentInputSlice = createSlice({
    name: "InvestmentInput",
    initialState,
    reducers: {
        setInvestmentInputId: (state, action: PayloadAction<string>) => {
            state.input.id = action.payload;
        },
        setInvestmentInput: (state, action: PayloadAction<InvestmentModel>) => {
            state.input = action.payload;
        },
        setItems: (state, action: PayloadAction<string>) => {
            state.input.items = action.payload;
        },
        setType: (state, action: PayloadAction<string>) => {
            state.input.type = action.payload;
        },
        setSettleDate: (state, action: PayloadAction<string>) => {
            state.input.settleDate = action.payload;
        },
        setInvestmentDate: (state, action: PayloadAction<string>) => {
            state.input.investmentDate = action.payload;
        },
        setInterest: (state, action: PayloadAction<number>) => {
            state.input.interest = action.payload;
        },
        setAmount: (state, action: PayloadAction<number>) => {
            state.input.amount = action.payload;
        },
        setDescription: (state, action: PayloadAction<string>) => {
            state.input.description = action.payload;
        },
        setSelectedInvestmentId: (state, action: PayloadAction<string>) => {
            state.selectedInvestmentId = action.payload;
        },
        setInvestmentInputExpand: (state, action: PayloadAction<boolean>) => {
            state.InvestmentInputExpand = action.payload;
        },
        setTriggerFocusCompanyNameInput: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyNameInput = action.payload;
        },
        resetInvestmentInput: (state) => {
            state.input = initialState.input;
        },
        setTriggerSave: (state, action: PayloadAction<number>) => {
            state.triggerSave = action.payload;
        },
        setTriggerRefreshInput: (state, action: PayloadAction<number>) => {
            state.triggerRefreshInput = action.payload;
        },
        setItemsAndTypes: (state, action: PayloadAction<ItemsAndTypesModel>) => {
            state.itemsAndTypes = action.payload;
        },
        setShowInvestmentDetail: (state, action: PayloadAction<boolean>) => {
            state.showInvestmentDetail = action.payload;
        },
    }
});

export const InvestmentInputSelector = createSelector(
    (state: RootState) => state.investmentInput,
    (data) => data
);

export const {
    setInvestmentInputId,
    setInvestmentInput,
    setItems,
    setType,
    setSettleDate,
    setInvestmentDate,
    setInterest,
    setAmount,
    setDescription,
    setSelectedInvestmentId,
    setInvestmentInputExpand,
    setTriggerFocusCompanyNameInput,
    resetInvestmentInput,
    setTriggerSave,
    setTriggerRefreshInput,
    setItemsAndTypes,
    setShowInvestmentDetail
} = InvestmentInputSlice.actions;

export default InvestmentInputSlice.reducer;